// Catalog tab filtering (matches the original Dynamic Vibe behavior)
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.tab-button');
  if (!btn) return;
  var wrap = btn.closest('[data-catalog]');
  if (!wrap) return;
  wrap.querySelectorAll('.tab-button').forEach(function (b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var filter = (btn.getAttribute('data-filter') || '').toLowerCase();
  wrap.querySelectorAll('.product-card').forEach(function (card) {
    var type = (card.getAttribute('data-type') || '').toLowerCase();
    card.style.display = (!filter || filter === 'all' || type === filter) ? '' : 'none';
  });
});

// Smooth scroll for in-page anchors
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var t = document.querySelector(this.getAttribute('href'));
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
  });
});
